import { BaSeContainer } from '@base/react';
import styled from 'styled-components';

export const ContainerMamageClass = styled(BaSeContainer)`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

export const ContentManageClass = styled.div`
  height: 100vh;
  // /* overflow-y: scroll; */
  // /* .BaSe--board--list--item--wrapper {
  //   height: 60vh;
  //   overflow-y: scroll;
  //  */

  // .BaSe--board-align-title-header {
  //   width: 100%;
  // }
`;

export const WrapperDialogReportCompreteError = styled(BaSeContainer)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const WrapperCandidatesWithoutQuestionnaire = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  gap: 10px;
`;

export const ContentDialog = styled.div`
  display: grid;
  gap: 12px;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
`;
